module.exports = __webpack_public_path__ + "img/arrow-down.9d847514.svg";